<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab color="error" dark v-bind="attrs" v-on="on">
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <!-- <v-card-title class="teal darken-3" dark>
        Register New Supplier
      </v-card-title> -->

      <v-toolbar dark color="teal darken-3">
        <v-toolbar-title>New Supplier</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn text icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-form ref="SupplierForm">
          <v-text-field
            outlined
            shaped
            v-model.trim="Supplier.SuppName"
            :rules="[rules.required]"
            label="Supplier Name"
            name="SupplierName"
            id="SupplierName"
          ></v-text-field>

          <v-text-field
            outlined
            shaped
            v-model.number="Supplier.SuppPhone"
            :rules="[rules.required]"
            type="number"
            label="Supplier Phone"
            id="SupplierPhone"
          ></v-text-field>
          <v-text-field
            outlined
            shaped
            v-model.number="Supplier.SuppCountry"
            :rules="[rules.required]"
            label="Supplier Country"
            id="SuppLierCountry"
          ></v-text-field>
          <v-text-field
            outlined
            shaped
            v-model.number="Supplier.Email"
            :rules="emailRules"
            label="Supplier Email"
            id="SupplierEmail"
          ></v-text-field>
          <v-select
            outlined
            shaped
            :items="GetCashTypes"
            v-model.number="Supplier.CashType"
            :rules="[v => !!v || 'Cash Type is required']"
            label="Cash Type"
            required
            no-data-text="Refresh the page"
          ></v-select>

          <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="isEditing"
          @click="CancelEdite"
          :loading="clicked"
          class="elevation-6"
          rounded
          color="error"
          dark
          width="150"
          >Cancel</v-btn
        >
        <v-spacer v-if="isEditing"></v-spacer>
        <v-btn
          :block="!isEditing"
          @click="UpdateOrSave"
          :loading="clicked"
          class="elevation-6"
          rounded
          color="teal darken-3"
          dark
          width="150"
          >{{ isEditing ? "Update" : "Save" }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    OnFinish: { type: Function, required: true },
    isEditing: { type: Boolean, required: true, default: false },
    OnEdite: { type: Object, required: true },
  },
  data() {
    return {
      ID: "",
      SuppURL: "/supplier",
      dialog: false,
      msgError: "",
      clicked: false,
      emailRules: [v => !!v || "E-mail is required"],
      Supplier: {
        SuppName: "",
        SuppPhone: "",
        SuppCountry: "",
        Email: "",
        CashType: null,
      },
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  watch: {
    isEditing(val) {
      if (val) {
        this.dialog = true;
        this.SuppEdite(this.OnEdite);
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.SupplierForm.reset();
      this.$emit("input", false);
    },
    UpdateOrSave() {
      if (this.isEditing) this.OnSupplierUpdate();
      else this.OnSupplierSave();
    },
    CancelEdite() {
      //   this.isEditing = false;
      this.close();
      this.msgError = "";
      //   this.$refs.SupplierForm.reset();
      this.ID = "";
    },
    OnSupplierUpdate() {
      // console.log("Updating");
      this.msgError = "";
      if (this.$refs.SupplierForm.validate() && this.ID) {
        this.clicked = true;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.SuppURL,
            data: { ...this.Supplier, ID: this.ID },
          })
          .then(result => {
            this.clicked = false;
            // this.$refs.SupplierForm.reset();
            // console.log(result);
            this.ID = "";
            this.OnFinish(result.data);
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response && err.response.data)
              this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    OnSupplierSave() {
      this.msgError = "";
      if (this.$refs.SupplierForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.SuppURL,
            data: this.Supplier,
          })
          .then(result => {
            this.clicked = false;
            this.$refs.SupplierForm.reset();
            // console.log(result);
            // this.AllSuppliers = result.data;
            this.OnFinish(result.data);
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    SuppEdite(E_Supp) {
      // console.log(E_Supp);
      this.ID = E_Supp._id;
      this.msgError = "";
      // this.isEditing = true;
      this.Supplier.SuppName = E_Supp.CostName;
      this.Supplier.SuppPhone = E_Supp.Contact;
      this.Supplier.SuppCountry = E_Supp.Country;
      this.Supplier.Email = E_Supp.Details;
      this.Supplier.CashType = E_Supp.CashType;
    },
  },
};
</script>
